<script>
    const { label, key } = $$props;
</script>

<svg class="legend-marker"><rect x="3" y="3" width="12" height="12" class="series-{key}"></rect></svg>{label}
